var I = Object.defineProperty;
var A = Object.getOwnPropertySymbols;
var Z = Object.prototype.hasOwnProperty, q = Object.prototype.propertyIsEnumerable;
var R = (l, t, o) => t in l ? I(l, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : l[t] = o, L = (l, t) => {
  for (var o in t || (t = {}))
    Z.call(t, o) && R(l, o, t[o]);
  if (A)
    for (var o of A(t))
      q.call(t, o) && R(l, o, t[o]);
  return l;
};
var P = (l, t, o) => new Promise((c, g) => {
  var _ = (m) => {
    try {
      u(o.next(m));
    } catch (y) {
      g(y);
    }
  }, b = (m) => {
    try {
      u(o.throw(m));
    } catch (y) {
      g(y);
    }
  }, u = (m) => m.done ? c(m.value) : Promise.resolve(m.value).then(_, b);
  u((o = o.apply(l, t)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import J from "./configurationGoods.vue.js";
import K from "./components/TemplateView.vue.js";
import { vCopyVueucStylesToShadowDom as Q } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { getList as W } from "../../request/commoditycenter/productClassification/list/get.js";
import { selfAxios as E } from "@oppein/op-utils";
import { vShadowPropertyPolyfill as X } from "../../utils/vShadowPropertyPolyfill.js";
import Y from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/loading-bar/src/LoadingBarProvider.js";
import { defineComponent as ee, provide as T, onMounted as oe, withDirectives as te, openBlock as ne, createBlock as ae, withCtx as D, createVNode as x } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as re } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { ref as d, unref as s } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import ie from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import se from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import le from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import pe from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const De = /* @__PURE__ */ ee({
  __name: "indexConfig.ce",
  emits: ["onChangeDeliveryMethod"],
  setup(l, { expose: t, emit: o }) {
    const c = re(), g = d(""), _ = d(""), b = d(""), u = d("");
    T("shadowRoot", c), T("appCode", g), T("subAppCode", _), T("oauth2AccessToken", b), T("env", u);
    const m = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    }, y = d(null), M = d(null), S = d(null), k = d(null);
    let n = null;
    const N = (e) => P(this, null, function* () {
      var r, f, i, p, C, v, w;
      return typeof e != "object" || e === null ? new Promise((h) => {
        n = h;
      }) : (Array.isArray((f = (r = e.inventory) == null ? void 0 : r.paramConfig) == null ? void 0 : f.details) && (e.inventory.paramConfig.details = e.inventory.paramConfig.details[0]), ((p = (i = e.inventory) == null ? void 0 : i.paramConfig) == null ? void 0 : p.details) && ((w = (v = (C = e.inventory) == null ? void 0 : C.paramConfig) == null ? void 0 : v.details) == null ? void 0 : w.classificationCode) ? yield O(e) : j(e), new Promise((h) => {
        n = h;
      }));
    }), O = (e) => P(this, null, function* () {
      var r, f, i, p, C;
      S.value = e.params;
      const a = yield W({});
      if (a.data && a.data.length > 0) {
        const v = {};
        a.data.forEach(({ id: w, templateCode: h }) => {
          if (w && h) {
            const $ = h.slice(h.indexOf("_") + 1);
            v[w] = $;
          }
        }), k.value = v;
      }
      z(), Array.isArray((f = (r = e.inventory) == null ? void 0 : r.paramConfig) == null ? void 0 : f.details) && (e.inventory.paramConfig.details = e.inventory.paramConfig.details[0]), (C = M.value) == null || C.show({
        detailsParam: (p = (i = e.inventory) == null ? void 0 : i.paramConfig) == null ? void 0 : p.details,
        store: e.store,
        orderParam: e.orderParam,
        canEdit: e.canEdit,
        localeParam: e.locale || "zh-CN"
      });
    }), z = () => {
      g.value = "MTDS", _.value = "MTDSPC001", b.value = E.defaults.headers.common["Oauth2-AccessToken"] || "";
      const e = E.defaults.baseURL;
      e === "https://apigatewayuat.oppein.com/" ? u.value = "uat" : e === "https://apigatewayver.oppein.com/" ? u.value = "ver" : e === "https://apigateway.oppein.com/" && (u.value = "pro");
    }, j = (e) => {
      var a;
      (a = y.value) == null || a.open({
        productType: e.productType || "",
        inventory: e.inventory || {},
        marketClassify: e.marketClassify || null,
        tagList: e.tagList || [],
        orderType: e.orderType || "LSD",
        batchDeliveryMethods: e.batchDeliveryMethods || null,
        noCheckConfig: e.noCheckConfig || null,
        destinationRegion: e.destinationRegion || null,
        locale: e.locale || "zh-CN"
      });
    }, F = (e) => {
      n && (n(e), n = null);
    }, V = (e) => {
      n && (n(e), n = null);
    }, B = () => {
      n && (n(null), n = null);
    }, H = () => {
      n && (n(null), n = null);
    }, G = (e, a, r) => {
      U("onChangeDeliveryMethod", e, a, r);
    }, U = o;
    return t({ open: N }), oe(() => {
      if (!c)
        return;
      const e = document.createElement("style");
      e.textContent = `
    /* 图片预览容器基础样式 */
    .n-image-preview-container {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1000;
      background: rgba(0, 0, 0, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    /* 预览图片样式 */
    .n-image-preview-content img {
      max-width: 90% !important;
      max-height: 90% !important;
      object-fit: contain !important;
    }
    /* 关闭按钮样式（根据需要调整） */
    .n-image-preview-close {
      position: absolute;
      top: 20px;
      right: 20px;
      color: #fff;
      font-size: 24px;
      cursor: pointer;
    }
    /* 其他需要的样式（如分页、导航按钮）可按需补充 */
  `, c.appendChild(e);
      const a = EventTarget.prototype.addEventListener;
      EventTarget.prototype.addEventListener = function(r, f, i) {
        if (r === "wheel") {
          let p;
          return typeof i == "boolean" ? p = { passive: !0, capture: i } : typeof i == "object" ? p = L({ passive: !0 }, i) : p = { passive: !0 }, a.call(this, r, f, p);
        }
        return a.call(this, r, f, i);
      };
    }), (e, a) => te((ne(), ae(s(le), {
      locale: s(ie),
      "date-locale": s(se),
      "theme-overrides": m,
      "style-mount-target": s(c),
      modal: {
        touchmove: { passive: !0 },
        // 解决 touchmove 滚动事件警告
        mousewheel: { passive: !0 },
        // 解决 mousewheel 滚动事件警告
        wheel: { passive: !0 }
      },
      "image-preview": {
        touchmove: { passive: !0 },
        // 图片预览组件的滚动事件
        mousewheel: { passive: !0 },
        wheel: { passive: !0 }
      }
    }, {
      default: D(() => [
        x(s(Y), null, {
          default: D(() => [
            x(s(pe), { to: s(c) }, {
              default: D(() => [
                x(J, {
                  ref_key: "configurationGoodRefs",
                  ref: y,
                  onOnChangeDeliveryMethod: G,
                  onSubmit: F,
                  onClose: B
                }, null, 512),
                x(K, {
                  ref_key: "TemplateViewRefs",
                  ref: M,
                  params: S.value,
                  componentMap: k.value,
                  onOnSuccess: V,
                  onHideDialog: H
                }, null, 8, ["params", "componentMap"])
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"])), [
      [s(Q), s(c)],
      [s(X), s(c)]
    ]);
  }
});
export {
  De as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/indexConfig.ce.vue2.js
// module id = 1270
// module chunks = 67